<script setup lang="ts">
    import KCell from "@/components/KTable/KCell.vue";
    import { computed, toRefs } from "vue";

    const props = defineProps<{
        data: {
            undantagskommentar?: string;
            tolk?: "JA";
            diabetes?: string;
            infoTillOpplaneringen?: string;
            infoTillKoordineringOchOperation?: string;
            preanestesibedomningInformationTillKoordinator?: string;
        };
    }>();

    const { data } = toRefs(props);

    const tooltipContent = computed(() => {
        const content = [
            data?.value?.undantagskommentar,
            data?.value?.tolk && data.value.tolk === "JA" ? "Tolk" : undefined,
            data?.value?.diabetes ? "Diabetes" : undefined,
            data?.value?.infoTillOpplaneringen,
            data?.value?.infoTillKoordineringOchOperation,
            data?.value?.preanestesibedomningInformationTillKoordinator,
        ].filter((row) => row);

        if (!content.length) {
            return undefined;
        }

        return content.map((row) => `<p>${row}</p>`).join("");
    });
</script>

<template>
    <KCell truncate class="cell-info-opplan" contentDirection="vertical" :tooltipContent="tooltipContent">
        <template #content>
            <span v-if="data?.undantagskommentar">{{ data.undantagskommentar }}</span>
            <span v-if="data?.tolk && data.tolk === 'JA'">Tolk</span>
            <span v-if="data?.diabetes">Diabetes</span>
            <span v-if="data?.infoTillOpplaneringen">{{ data.infoTillOpplaneringen }}</span>
            <span v-if="data?.infoTillKoordineringOchOperation">{{ data.infoTillKoordineringOchOperation }}</span>
            <span v-if="data?.preanestesibedomningInformationTillKoordinator">{{
                data.preanestesibedomningInformationTillKoordinator
            }}</span>
        </template>
    </KCell>
</template>

<style scoped lang="scss">
    .cell-info-opplan {
    }
</style>
